import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import mtaImg from '../assets/mta.jpg';
import { COUNTRIES_CITIES, PHONE_CODES } from '../data/geoData';
import './GestionTransport.css';

const AVANTAGES = [
  {
    title: 'Coordination complète',
    desc: 'Nous coordonnons l\'intégralité de la chaîne logistique entre les fournisseurs, transitaires et douanes pour une livraison sans friction.',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>,
  },
  {
    title: 'Suivi en temps réel',
    desc: 'Visibilité complète sur la localisation de vos marchandises à chaque étape du transit, de l\'usine jusqu\'à votre entrepôt.',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
  },
  {
    title: 'Gestion documentaire',
    desc: 'Préparation et vérification de tous les documents douaniers, certificats et documents de transport pour éviter tout blocage.',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="15" y2="17"/></svg>,
  },
  {
    title: 'Multi-modal & Flexible',
    desc: 'Transport maritime (FCL/LCL), aérien et ferroviaire selon vos délais et budgets, depuis la Chine, l\'Asie du Sud-Est ou tout autre pays.',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
  },
];

const STEPS = [
  { num: '01', title: 'Analyse des besoins', desc: 'Étude de vos volumes, contraintes de délais, incoterms et budget pour définir la meilleure stratégie logistique.' },
  { num: '02', title: 'Préparation expédition', desc: 'Coordination avec le fournisseur pour l\'emballage, le marquage et la mise à disposition des marchandises.' },
  { num: '03', title: 'Réservation fret', desc: 'Sélection du transporteur, réservation des espaces et obtention des meilleurs tarifs pour votre envoi.' },
  { num: '04', title: 'Exportation', desc: 'Gestion des formalités douanières à l\'export, inspection de la marchandise et chargement sécurisé.' },
  { num: '05', title: 'Suivi du fret', desc: 'Tracking en temps réel de votre cargaison avec alertes proactives à chaque étape du transit.' },
  { num: '06', title: 'Livraison & Dédouanement', desc: 'Gestion du dédouanement à l\'import, paiement des droits et livraison finale en vos entrepôts.' },
];

const COMPARE = [
  { aspect: 'Coordination logistique', avec: 'Coordination complète entre tous les acteurs de la chaîne', sans: 'Manque de coordination, délais imprévisibles' },
  { aspect: 'Coûts de fret', avec: 'Tarifs négociés grâce à notre réseau de partenaires', sans: 'Coûts non maîtrisés et surprises tarifaires' },
  { aspect: 'Documents douaniers', avec: 'Documentation conforme préparée et vérifiée', sans: 'Risques de blocage douanier et pénalités' },
  { aspect: 'Visibilité transport', avec: 'Suivi en temps réel via notre portail de tracking', sans: 'Aucune visibilité sur l\'avancement des expéditions' },
  { aspect: 'Conformité réglementaire', avec: 'Respect des réglementations douanières et sanitaires', sans: 'Risques de non-conformité et contentieux' },
];

const SERVICES = [
  { title: 'Transport maritime', desc: 'Solutions FCL et LCL depuis les principaux ports d\'Asie vers la France, la Belgique et l\'Europe.', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/></svg> },
  { title: 'Transport aérien', desc: 'Fret aérien express pour vos marchandises urgentes avec suivi en temps réel de votre envoi.', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/></svg> },
  { title: 'Transport ferroviaire', desc: 'Liaison ferroviaire Chine-Europe (Nouvelle Route de la Soie) : compromis idéal délai/coût.', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="3" width="16" height="16" rx="2"/><path d="M4 11h16"/><path d="M12 3v8"/><circle cx="8.5" cy="17" r="1.5"/><circle cx="15.5" cy="17" r="1.5"/><path d="M8.5 19l-1.5 2"/><path d="M15.5 19l1.5 2"/></svg> },
  { title: 'Dédouanement', desc: 'Gestion complète des formalités douanières à l\'import et à l\'export pour éviter tout blocage.', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg> },
  { title: 'Entreposage', desc: 'Solutions de stockage temporaire en Chine, en France et en Belgique avant redistribution finale.', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg> },
  { title: 'Assurance marchandises', desc: 'Couverture assurantielle adaptée pour protéger vos marchandises durant tout le transport.', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg> },
];

const FAQS = [
  { q: 'Quels modes de transport proposez-vous depuis la Chine ?', a: 'Nous proposons le transport maritime (FCL container complet / LCL groupage), le transport aérien express, et la liaison ferroviaire Chine-Europe (Nouvelle Route de la Soie). Nous vous recommandons la solution optimale selon vos volumes, délais et budgets.' },
  { q: 'Quels sont les délais de transit depuis la Chine ?', a: 'Les délais varient selon le mode : maritime 25-40 jours, ferroviaire 18-22 jours, aérien 5-10 jours. Ces délais incluent le transit et le dédouanement à l\'arrivée.' },
  { q: 'Quels documents sont nécessaires pour l\'importation ?', a: 'Les documents principaux sont : la facture commerciale, la liste de colisage, le connaissement maritime (B/L) ou la lettre de transport aérien (LTA), le certificat d\'origine, et selon les produits, les certificats CE, phytosanitaires ou autres.' },
  { q: 'Comment fonctionne le suivi de mes expéditions ?', a: 'Dès la prise en charge de votre marchandise, vous recevez un numéro de tracking qui vous permet de localiser en temps réel votre cargaison à chaque étape clé : départ usine, chargement, transit, arrivée port, dédouanement et livraison finale.' },
  { q: 'Gérez-vous le transport depuis d\'autres pays d\'Asie ?', a: 'Oui, au-delà de la Chine, nous gérons le transport depuis le Vietnam, l\'Indonésie, la Malaisie, la Thaïlande, le Cambodge, Singapour et d\'autres pays. Notre réseau de partenaires locaux nous permet d\'intervenir dans toute l\'Asie du Sud-Est.' },
];

const REQUIRED = ['nom', 'email', 'villeDepart', 'villeArrivee'];

const INIT = {
  nom: '', prenom: '', email: '',
  indicatifPays: 'France', telephone: '',
  entreprise: '',
  sujet: '',
  paysDepart: '', villeDepart: '',
  paysArrivee: '', villeArrivee: '',
  message: '',
};

export default function GestionTransport() {
  const [openFaq, setOpenFaq] = useState(null);
  const [form, setForm] = useState(INIT);
  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const formRef = useRef(null);
  const navigate = useNavigate();

  const villsDepart = COUNTRIES_CITIES.find(c => c.pays === form.paysDepart)?.villes || [];
  const villsArrivee = COUNTRIES_CITIES.find(c => c.pays === form.paysArrivee)?.villes || [];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(f => {
      const next = { ...f, [name]: value };
      if (name === 'paysDepart') next.villeDepart = '';
      if (name === 'paysArrivee') next.villeArrivee = '';
      return next;
    });
    if (errors[name]) setErrors(er => ({ ...er, [name]: '' }));
  };

  const validate = () => {
    const errs = {};
    if (!form.nom.trim()) errs.nom = 'Ce champ est obligatoire';
    if (!form.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) errs.email = 'Adresse email invalide';
    if (!form.entreprise) errs.entreprise = 'Ce champ est obligatoire';
    if (!form.villeDepart) errs.villeDepart = 'Ce champ est obligatoire';
    if (!form.villeArrivee) errs.villeArrivee = 'Ce champ est obligatoire';
    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setSending(true);
    try {
      const selectedPhone = PHONE_CODES.find(p => p.pays === form.indicatifPays);
      const payload = { ...form, indicatif: selectedPhone ? `${selectedPhone.flag} ${selectedPhone.code}` : '' };
      const res = await fetch('http://localhost:5001/api/transport-quote', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (res.ok) { setSent(true); setForm(INIT); }
      else { const d = await res.json(); alert(d.error || 'Erreur lors de l\'envoi.'); }
    } catch { alert('Erreur réseau. Veuillez réessayer.'); }
    finally { setSending(false); }
  };

  const scrollToForm = () => formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });

  return (
    <div className="gt-page">

      {/* ── HERO ── */}
      <section className="gt-hero">
        <div className="gt-hero__bg" style={{ backgroundImage: `url(${mtaImg})` }} />
        <div className="gt-hero__inner">
          <p className="gt-hero__eye">Nos Services</p>
          <h1 className="gt-hero__h1">Gestion du Transport,<br /><strong>logistique sûre & sans stress</strong></h1>
          <p className="gt-hero__sub">Sécurisez l'expédition de vos marchandises depuis la Chine et l'Asie grâce à notre réseau de partenaires en France, en Belgique et en Chine.</p>
          <div className="gt-hero__actions">
            <button className="gt-btn gt-btn--primary" onClick={scrollToForm}>Demandez un devis de transport</button>
            <a href="#gt-processus" className="gt-btn gt-btn--ghost">Notre processus</a>
          </div>
        </div>
      </section>

      {/* ── AVANTAGES ── */}
      <section className="gt-avantages">
        <div className="gt-avantages__inner">
          <p className="gt-eyebrow">Pourquoi nous choisir</p>
          <h2 className="gt-h2">Une logistique <strong>coordonnée de bout en bout</strong></h2>
          <p className="gt-lead">De l'usine à votre entrepôt, chaque étape du transport est maîtrisée par notre équipe et nos partenaires locaux.</p>
          <div className="gt-avantages__grid">
            {AVANTAGES.map(a => (
              <div key={a.title} className="gt-card">
                <div className="gt-card__icon">{a.icon}</div>
                <h3 className="gt-card__title">{a.title}</h3>
                <p className="gt-card__desc">{a.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── PROCESSUS ── */}
      <section className="gt-processus" id="gt-processus">
        <div className="gt-processus__inner">
          <p className="gt-eyebrow">Notre méthodologie</p>
          <h2 className="gt-h2">Un processus en <strong>6 étapes maîtrisées</strong></h2>
          <p className="gt-lead">Chaque expédition suit un protocole rigoureux pour garantir sécurité, conformité et ponctualité.</p>
          <div className="gt-processus__steps">
            {STEPS.map(s => (
              <div key={s.num} className="gt-step">
                <div className="gt-step__num">{s.num}</div>
                <h3 className="gt-step__title">{s.title}</h3>
                <p className="gt-step__desc">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── COMPARATIF ── */}
      <section className="gt-compare">
        <div className="gt-compare__inner">
          <p className="gt-eyebrow">Analyse comparative</p>
          <h2 className="gt-h2" style={{ color: '#fff' }}>Avec GSSG vs <strong>sans GSSG</strong></h2>
          <div style={{ overflowX: 'auto' }}>
            <table className="gt-compare__table">
              <thead>
                <tr><th>Critère</th><th>✓ Avec GSSG</th><th>Sans GSSG</th></tr>
              </thead>
              <tbody>
                {COMPARE.map(r => (
                  <tr key={r.aspect}>
                    <td>{r.aspect}</td>
                    <td><span className="gt-check">✓</span> {r.avec}</td>
                    <td><span className="gt-cross">✗</span> {r.sans}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* ── SERVICES ── */}
      <section className="gt-services">
        <div className="gt-services__inner">
          <p className="gt-eyebrow">Ce que nous faisons</p>
          <h2 className="gt-h2">Nos <strong>prestations logistiques</strong></h2>
          <p className="gt-lead">Une gamme complète de services pour tous vos besoins de transport international.</p>
          <div className="gt-services__grid">
            {SERVICES.map(s => (
              <div key={s.title} className="gt-svc">
                <div className="gt-svc__icon">{s.icon}</div>
                <h3 className="gt-svc__title">{s.title}</h3>
                <p className="gt-svc__desc">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section className="gt-faq">
        <div className="gt-faq__inner">
          <p className="gt-eyebrow">Questions fréquentes</p>
          <h2 className="gt-h2">Tout ce que vous devez <strong>savoir</strong></h2>
          <div className="gt-faq__list">
            {FAQS.map((faq, i) => (
              <div key={i} className="gt-faq__item">
                <button className={`gt-faq__q${openFaq === i ? ' gt-faq__q--open' : ''}`} onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                  {faq.q}
                  <svg className="gt-faq__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>
                </button>
                <div className={`gt-faq__a${openFaq === i ? ' gt-faq__a--open' : ''}`}>{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FORMULAIRE DEVIS ── */}
      <section className="gt-form-section" ref={formRef} id="gt-devis">
        <div className="gt-form-section__inner">
          <p className="gt-eyebrow">Demande de devis</p>
          <h2 className="gt-h2">Demandez un <strong>devis de transport</strong></h2>
          <p className="gt-lead">Remplissez le formulaire ci-dessous et nous vous répondons sous 48h avec une proposition adaptée.</p>

          <div className="gt-form">
            {sent ? (
              <div className="gt-form__success">
                <h3>✓ Demande envoyée avec succès !</h3>
                <p>Nous avons bien reçu votre demande de devis et vous répondrons sous 48h à l'adresse <strong>{form.email || 'indiquée'}</strong>.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} noValidate>
                <div className="gt-form__grid">

                  {/* Nom */}
                  <div className="gt-form__group">
                    <label className="gt-form__label">Nom <span>*</span></label>
                    <input name="nom" value={form.nom} onChange={handleChange} className={`gt-form__input${errors.nom ? ' error' : ''}`} placeholder="Votre nom" />
                    {errors.nom && <span className="gt-form__error">{errors.nom}</span>}
                  </div>

                  {/* Prénom */}
                  <div className="gt-form__group">
                    <label className="gt-form__label">Prénom</label>
                    <input name="prenom" value={form.prenom} onChange={handleChange} className="gt-form__input" placeholder="Votre prénom" />
                  </div>

                  {/* Email */}
                  <div className="gt-form__group">
                    <label className="gt-form__label">Email <span>*</span></label>
                    <input name="email" type="email" value={form.email} onChange={handleChange} className={`gt-form__input${errors.email ? ' error' : ''}`} placeholder="votre@email.com" />
                    {errors.email && <span className="gt-form__error">{errors.email}</span>}
                  </div>

                  {/* Téléphone */}
                  <div className="gt-form__group">
                    <label className="gt-form__label">Téléphone <small style={{color:'#94a3b8',fontWeight:400}}>(facultatif)</small></label>
                    <div className="gt-form__phone-wrap">
                      <select name="indicatifPays" value={form.indicatifPays} onChange={handleChange} className="gt-form__indicatif">
                        {PHONE_CODES.map(p => (
                          <option key={p.pays} value={p.pays}>{p.flag} {p.code}</option>
                        ))}
                      </select>
                      <input
                        name="telephone"
                        value={form.telephone}
                        onChange={e => {
                          const val = e.target.value.replace(/[^\d\s\-]/g, '');
                          setForm(f => ({ ...f, telephone: val }));
                        }}
                        className="gt-form__tel-input"
                        placeholder="Numéro de téléphone"
                        inputMode="numeric"
                      />
                    </div>
                  </div>

                  {/* Entreprise */}
                  <div className="gt-form__group gt-form__group--full">
                    <label className="gt-form__label">Êtes-vous une entreprise ? <span>*</span></label>
                    <select name="entreprise" value={form.entreprise} onChange={handleChange} className={`gt-form__select${errors.entreprise ? ' error' : ''}`}>
                      <option value="">-- Sélectionner --</option>
                      <option value="Oui">Oui</option>
                      <option value="Non">Non</option>
                    </select>
                    {errors.entreprise && <span className="gt-form__error">{errors.entreprise}</span>}
                  </div>

                  {/* Sujet */}
                  <div className="gt-form__group gt-form__group--full">
                    <label className="gt-form__label">Sujet</label>
                    <input name="sujet" value={form.sujet} onChange={handleChange} className="gt-form__input" placeholder="Objet de votre demande" />
                  </div>

                  {/* Pays départ */}
                  <div className="gt-form__group">
                    <label className="gt-form__label">Pays de départ</label>
                    <select name="paysDepart" value={form.paysDepart} onChange={handleChange} className="gt-form__select">
                      <option value="">-- Sélectionner --</option>
                      {COUNTRIES_CITIES.map(c => <option key={c.pays} value={c.pays}>{c.pays}</option>)}
                    </select>
                  </div>

                  {/* Ville départ */}
                  <div className="gt-form__group">
                    <label className="gt-form__label">Ville de départ <span>*</span></label>
                    <select name="villeDepart" value={form.villeDepart} onChange={handleChange} className={`gt-form__select${errors.villeDepart ? ' error' : ''}`} disabled={!form.paysDepart}>
                      <option value="">{form.paysDepart ? '-- Sélectionner --' : '-- Choisir un pays d\'abord --'}</option>
                      {villsDepart.map(v => <option key={v} value={v}>{v}</option>)}
                    </select>
                    {errors.villeDepart && <span className="gt-form__error">{errors.villeDepart}</span>}
                  </div>

                  {/* Pays arrivée */}
                  <div className="gt-form__group">
                    <label className="gt-form__label">Pays d'arrivée</label>
                    <select name="paysArrivee" value={form.paysArrivee} onChange={handleChange} className="gt-form__select">
                      <option value="">-- Sélectionner --</option>
                      {COUNTRIES_CITIES.map(c => <option key={c.pays} value={c.pays}>{c.pays}</option>)}
                    </select>
                  </div>

                  {/* Ville arrivée */}
                  <div className="gt-form__group">
                    <label className="gt-form__label">Ville d'arrivée <span>*</span></label>
                    <select name="villeArrivee" value={form.villeArrivee} onChange={handleChange} className={`gt-form__select${errors.villeArrivee ? ' error' : ''}`} disabled={!form.paysArrivee}>
                      <option value="">{form.paysArrivee ? '-- Sélectionner --' : '-- Choisir un pays d\'abord --'}</option>
                      {villsArrivee.map(v => <option key={v} value={v}>{v}</option>)}
                    </select>
                    {errors.villeArrivee && <span className="gt-form__error">{errors.villeArrivee}</span>}
                  </div>

                  {/* Message */}
                  <div className="gt-form__group gt-form__group--full">
                    <label className="gt-form__label">Message</label>
                    <textarea name="message" value={form.message} onChange={handleChange} className="gt-form__textarea" placeholder="Décrivez votre besoin : nature des marchandises, volume, délais souhaités…" />
                  </div>

                  <div className="gt-form__submit">
                    <button type="button" className="gt-form__btn-cancel" onClick={() => { setForm(INIT); setErrors({}); }}>
                      Annuler la demande
                    </button>
                    <button type="submit" className="gt-form__btn" disabled={sending}>
                      {sending ? 'Envoi en cours…' : 'Envoyer la demande'}
                    </button>
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="gt-cta">
        <h2 className="gt-cta__h2">Prêt à expédier vos marchandises <strong>en toute sérénité ?</strong></h2>
        <p className="gt-cta__sub">Notre équipe vous accompagne de A à Z pour un transport sûr, fiable et ponctuel.</p>
        <button className="gt-btn gt-btn--primary" onClick={scrollToForm}>Demander un devis gratuit</button>
      </section>

    </div>
  );
}
